<template>
  <div class="sim-list-container">
    <div class="box" v-for="(item, index) in list" :key="index">
      <!-- 左上角装饰角标 -->
      <div class="corner-mark" :style="getCornerMarkStyle(item)"></div>

      <!-- 左侧内容区域 (垂直布局) -->
      <div class="title" @dblclick="copyICCID(item.iccid)">
        <!-- 顶部：ICCID (独占一行) -->
        <div class="methodTitle">
          <h3 class="label">ICCID</h3>
          <h3 class="iccid-text">{{ formatICCID(item.iccid) }}</h3>
        </div>

        <!-- 底部：三列信息 (与右侧按钮同行) -->
        <div class="methodSlidebt">
          <ul>
            <li>
              <h3>状态</h3>
              <p :style="getStatusStyle(item)">
                  {{ getStatusText(item.status,item.off_reason) }}
              </p>
            </li>
            <li>
              <h3>到期日</h3>
              <p :class="{ 'expire-soon': checkExpire(item.off_time, 7) }">
                {{ formatDate(item.off_time) }}
              </p>
            </li>
            <li>
              <h3>剩余流量</h3>
              <p :class="{ 'low-flow': item.remain_flow < 10 }">
                {{ formatFlow(item.remain_flow) }}
              </p>
            </li>
          </ul>
        </div>
      </div>

      <!-- 右侧按钮 (与底部信息垂直居中) -->
      <div class="btn">
        <van-button plain round size="small" color="#b9b9b9" @click="boxBtn(item.iccid)">
          充值
        </van-button>
         <van-button plain round size="small" color="#b9b9b9" @click="allocateBtn(item.iccid)">
            划拨
          </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import yans1 from '@/assets/yans-1.png' // 激活
import yans2 from '@/assets/yans-2.png' // 停机
import yans3 from '@/assets/yans-3.png' // 预警
import { copyText } from '@/utils/copy.js'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    searchValue: {
      type: String
    }
  },
  methods: {
    boxBtn (iccid) {
      if (this.searchValue && this.searchValue === iccid) {
        // 记录查询
        sessionStorage.setItem('SimList-searchValue', iccid)
      }
      this.$router.push({
        name: 'packageAgent',
        params: {
          iccid: iccid
        }
      })
    },
    allocateBtn (iccid) {
      if (this.searchValue && this.searchValue === iccid) {
        // 记录查询
        sessionStorage.setItem('SimList-searchValue', iccid)
      }
      this.$router.push({
        name: 'SimTransfer',
        params: {
          iccid: iccid
        }
      })
    },
    async copyICCID (iccid) {
      copyText(iccid)
    },
    formatICCID (iccid) {
      if (!iccid) return ''
      const str = String(iccid)
      // 4位一分隔
      return str.match(/.{1,4}/g).join(' ')
    },
    checkExpire (timeStr, days = 3) {
      if (!timeStr) return false
      const now = new Date().getTime()
      const end = new Date(timeStr).getTime()
      const limit = days * 24 * 60 * 60 * 1000
      return (end - now) > 0 && (end - now) <= limit
    },
    formatDate (dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      if (isNaN(date.getTime())) return '-'
      const year = String(date.getFullYear()).slice(-2)
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatFlow (val) {
      const num = parseFloat(val)
      if (isNaN(num)) return '0.00MB'
      return num.toFixed(2) + 'MB'
    },
    getStatusText (status, offReason) {
      if (status === '04' && offReason === 1) {
        return '机卡分离'
      }
      const statusMap = {
        '01': '可测试',
        '02': '待激活',
        '03': '已激活',
        '04': '已停机',
        '05': '预销户',
        '06': '已销户',
        '07': '已失效'
      }
      return statusMap[status] || '未知'
    },
    getStatusStyle (obj) {
      // 注意：这里原代码是 remainFlow，需确保字段名一致，如果是 remain_flow 请修改
      const flow = obj.remain_flow !== undefined ? obj.remain_flow : obj.remainFlow
      switch (obj.status) {
        case '03':
        case '01':
        case '02':
          return flow < 10 ? 'color: #ffad1e;' : 'color: #41c584;'
        case '04':
          return 'color: #ff4427;'
        default:
          return ''
      }
    },
    getCornerMarkStyle (obj) {
      let bgImg = yans3 // 预警
      const flow = obj.remain_flow !== undefined ? obj.remain_flow : obj.remainFlow

      if (obj.status === '04') {
        bgImg = yans2
      } else if (obj.status === '03' || obj.status === '02' || obj.status === '01') {
        bgImg = flow < 10 ? yans3 : yans1
      } else {
        return {} // 返回空对象防止报错
      }
      return {
        backgroundImage: `url(${bgImg})`
      }
    }
  }
}
</script>

<style scoped lang="less">
.sim-list-container {
  padding-bottom: 20px;
}

.box {
  width: 690px;
  /* 高度改为 auto 自适应，或者保持固定高度但需确保内容不溢出 */
  min-height: 160px;
  background-color: #fff;
  margin: 0 auto 20px;
  box-shadow: 0 4px 10px 5px rgba(15, 27, 115, 0.08);
  border-radius: 15px;
  position: relative;
  /* 主轴水平排列：左边内容，右边按钮 */
  display: flex;
  justify-content: space-between;
  align-items: center; /* 垂直居中：让按钮与底部信息对齐 */
  padding: 20px 0; /* 上下内边距 */
  box-sizing: border-box;
  overflow: hidden;

  .corner-mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 32px;
    height: 32px;
    background-size: 100%;
    z-index: 1;
  }

  /* 左侧大容器：占据剩余空间，垂直排列 */
  .title {
    flex: 1; /* 占据除按钮外的所有宽度 */
    display: flex;
    flex-direction: column; /* 垂直堆叠：ICCID在上，列表在下 */
    justify-content: space-between;
    height: 100%;
    padding-left: 40px;
    padding-right: 20px;
    box-sizing: border-box;

    .methodTitle {
      display: flex;
      align-items: center;
      margin-bottom: 15px; /* 与底部信息的间距 */

      h3 {
        font-size: 30px;
        color: #272729;
        font-weight: 400;
        line-height: 1;
      }

      .label {
        margin-right: 15px;
        color: #9D9DA3;
      }

      .iccid-text {
        word-break: break-all; /* 防止长ICCID溢出 */
      }
    }

    .methodSlidebt {
      /* 这一层不需要特殊样式，主要靠 ul 控制 */
      ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center; /* 确保文字与右侧按钮垂直居中 */

        li {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          h3 {
            font-size: 24px;
            color: #9D9DA3;
            margin-bottom: 8px;
            line-height: 1;
          }

          p {
            font-size: 26px;
            color: #272729;
            line-height: 1;
            margin: 0;
          }

          .low-flow {
            color: #ed6a0c!important;
            font-weight: bold;
          }
        }
      }
    }
  }

  .btn {
    /* 按钮区域固定宽度或自适应，靠右 */
    flex-shrink: 0; /* 防止被压缩 */
    padding-right: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px; /* 按钮之间的间距 */
  }

  .btn .van-button {
    width: 100px;
    height: 56px;
    font-size: 26px;
  }
  /* 即将过期样式 */
  .expire-soon {
    color: #ed6a0c!important;
    font-weight: bold;
  }
}
</style>
